import { Component, ElementRef, ViewChild } from "@angular/core";
import { VehiclesService } from "../../../../shared/services/vehicles.service";
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { TipoMantenimientoService } from "../../../../shared/services/tipo_mantenimiento.service";
import { EmpresasService } from "../../../../shared/services/empresas.service";
import { PropietarioService } from "../../../../shared/services/propietarios.service";
import { Propietario } from "../../../../shared/model/propietario";
import { FormaPagoService } from "../../../../shared/services/forma_pago.service";
import {
  TipoAccion,
  TipoAccionService,
} from "../../../../shared/services/tipo_accion.service";
import {
  ServicioRealizado,
  ServicioRealizadoService,
} from "../../../../shared/services/servicio_realizado.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { MantenimientoService } from "../../../../shared/services/mantenimientos.service";
import {
  SistemaMantenimiento,
  SistemaMantenimientoService,
} from "../../../../shared/services/sistema_mantenimiento.service";
import { ParteMantenimientoService } from "../../../../shared/services/parte_mantenimiento.service";
import { DomSanitizer } from "@angular/platform-browser";
import { NgSelectComponent } from "@ng-select/ng-select";
import { DataService } from "../../../../shared/services/municipios.service";
import { HttpEventType } from "@angular/common/http";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { DigitalesService } from "../../../../shared/services/digitales.service";
import { Administracion } from "../../../../shared/model/administracion.model";

declare var require: any;
const Swal = require("sweetalert2");

export function noEspaciosEnBlanco(): ValidatorFn {
  return (control: AbstractControl) => {
    const valor = control.value;
    if (typeof valor === "string" && valor.trim() === "") {
      return { espaciosBlancos: true };
    }
    return null;
  };
}

@Component({
  selector: "app-registrar",
  templateUrl: "./registrar.component.html",
  styleUrls: ["./registrar.component.scss"],
})
export class RegistrarComponent {
  @ViewChild("inputSistema") inputSistema!: ElementRef;
  @ViewChild("inputParte") inputParte!: ElementRef;
  @ViewChild("inputNit") inputNit!: ElementRef;
  @ViewChild("inputNombre") inputNombre!: ElementRef;
  @ViewChild("inputCodigo") inputCodigo!: ElementRef;
  @ViewChild("inputDireccion") inputDireccion!: ElementRef;
  @ViewChild("inputCiudad") inputCiudad!: ElementRef;
  @ViewChild("inputCelular") inputCelular!: ElementRef;
  @ViewChild("inputEmail") inputEmail!: ElementRef;
  @ViewChild("inputTipo") inputTipo!: ElementRef;
  @ViewChild("inputFecha") inputFecha!: ElementRef;
  @ViewChild("inputPlaca") inputPlaca!: NgSelectComponent;
  @ViewChild("inputKm") inputKm!: ElementRef;
  @ViewChild("inputtipo") inputTipoMante!: NgSelectComponent;
  @ViewChild("inputTaller") inputTaller!: NgSelectComponent;
  @ViewChild("inputConductor") inputConductor!: NgSelectComponent;
  @ViewChild("inputFactura") inputFactura!: ElementRef;
  @ViewChild("inputForma") inputForma!: NgSelectComponent;
  @ViewChild("inputAccion") inputAccion!: NgSelectComponent;
  @ViewChild("inputVrPagos") inputVrPagos!: ElementRef;
  @ViewChild("inputServicio") inputServicio!: NgSelectComponent;

  respuestaVehiculos: any;
  vehiculos: any[] = [];
  formNuevo!: FormGroup;
  vehiculoSeleccionado: any = null;
  TipoMantenimiento: any;
  empresaTaller: any;
  conductor!: Propietario[];
  formapago: any;
  tipoaccion!: TipoAccion[];
  servicioRealizado!: ServicioRealizado[];
  editMode!: boolean;
  formServicio!: FormGroup;
  modalServicioRef!: NgbModalRef;
  servicioSeleccionado: number | undefined;
  servicios!: { data: ServicioRealizado[] };
  formMantenimiento!: FormGroup;
  valorFormateado: string = "";
  sistemaMantenimiento!: SistemaMantenimiento[];
  parteMantenimiento!: any[];
  empresaselecionada: any;
  formEmpresa!: FormGroup;
  modalEmpresaRef!: NgbModalRef;
  empresas!: any;
  empresaSeleccionada!: string;
  maxDate!: string;
  documentoId!: number;
  numeroDocumento!: string;
  formDocumentos!: FormGroup;
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;
  formMantenimientos!: FormGroup;
  mantenimientos: any[] = [];
  validate: boolean = false;
  municipios!: any[];
  validFiles: File[] = [];
  administraciones: Administracion[] = [];

  constructor(
    private propietariosService: PropietarioService,
    private vehiclesService: VehiclesService,
    private tipoMantenimientosService: TipoMantenimientoService,
    private empresasService: EmpresasService,
    private forma_pagoService: FormaPagoService,
    private tipo_accionService: TipoAccionService,
    private servicio_realizadoService: ServicioRealizadoService,
    private matenimientosService: MantenimientoService,
    private sistema_mantenimientoService: SistemaMantenimientoService,
    private parte_mantenimientoService: ParteMantenimientoService,
    private fb: FormBuilder,
    private dataService: DataService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
     private digitalesService: DigitalesService,
     private administracionesServices: AdministracionService
  ) {}

  ngOnInit() {
    this.cargarDataAdmin();
    this.cargarVehiculos();
    this.cargarMantenimiento();
    this.cargarTaller();
    this.cargarConductor();
    this.cargarForma_pago();
    this.cargarTipo_accion();
    this.cargarServicio_realizado();
    this.cargarSistema_mantenimiento();
    this.cargarParte_mantenimiento();
    this.cargarMunicipios();

    this.formServicio = this.fb.group({
      sistema: [null],
      parte: [null],
      tipo_de_mantenimiento: [null],
    });

    this.formEmpresa = this.fb.group({
      nit: ["", [Validators.pattern(/^[0-9]{10}$/)]],
      digito: [null],
      nombre: [null],
      direccion: [null],
      telefono: ["", [Validators.pattern(/^[0-9]{10}$/)]],
      celular: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: [null],
      observaciones: [null],
      ciudad: [null],
      eps: [false],
      arl: [false],
      afp: [false],
      ces: [false],
      ccf: [false],
      bancos: [false],
      transporte: [false],
      colegio: [false],
      cda: [false],
      taller: [false],
      eds: [false],
      contratista: [false],
      proveedor: [false],
      aseguradora: [false],
      almacen: [false],
      serviteca: [false],
      estado: [1],
    });

    this.formMantenimiento = this.fb.group({
      fecha: [null, [Validators.required]],
      placa: [null, [Validators.required, noEspaciosEnBlanco()]],
      km: [null, [Validators.required]],
      idTipoMantenimiento: [null, [Validators.required]],
      taller: [null, [Validators.required]],
      servicio: [null, [Validators.required]],
      idAccion: [null, [Validators.required]],
      factura: [null, [Validators.required, noEspaciosEnBlanco()]],
      vrpagos: [null],
      idFormaPago: [null, [Validators.required]],
      conductor: [null, [Validators.required]],
      observacion: [null, [noEspaciosEnBlanco()]],
    });

    this.formDocumentos = this.fb.group({
      id: [null],
      factura: [null],
      documento: [null],
    });

    this.formMantenimientos = this.fb.group({
      mantenimientos: this.fb.array([]),
    });

    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const parts = formatter.formatToParts(new Date());
    const year = parts.find((p) => p.type === "year")?.value;
    const month = parts.find((p) => p.type === "month")?.value;
    const day = parts.find((p) => p.type === "day")?.value;

    this.maxDate = `${year}-${month}-${day}`;
  }

  private cargarVehiculos(): void {
    this.vehiclesService.getPlacas().subscribe({
      next: (data) => (this.vehiculos = data),
      error: (error) => console.error("❌ Error al obtener vehículos:", error),
    });
  }

  private cargarMantenimiento(): void {
    this.tipoMantenimientosService.getTipos().subscribe({
      next: (data) => (this.TipoMantenimiento = data),
      error: (error) =>
        console.error("❌ Error al obtener el mantenimiento:", error),
    });
  }

  private cargarTaller(): void {
    this.empresasService.getTaller().subscribe({
      next: (data) => (this.empresaTaller = data),
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarConductor(): void {
    this.propietariosService.getConductores().subscribe({
      next: (data) => (this.conductor = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener conductores:", error),
    });
  }

  private cargarForma_pago(): void {
    this.forma_pagoService.getFormasPago().subscribe({
      next: (data) => (this.formapago = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener forma de pago:", error),
    });
  }

  private cargarTipo_accion(): void {
    this.tipo_accionService.getAll().subscribe({
      next: (data) => (this.tipoaccion = data.data), // ✅ solo el array
      error: (error) =>
        console.error("❌ Error al obtener tipo de acción:", error),
    });
  }

  private cargarServicio_realizado(): void {
    this.servicio_realizadoService.getAll().subscribe({
      next: (data) => (this.servicioRealizado = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener servicio realizado:", error),
    });
  }

  private cargarSistema_mantenimiento(): void {
    this.sistema_mantenimientoService.getAll().subscribe({
      next: (data) => (this.sistemaMantenimiento = data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener sistema mantenimiento:", error),
    });
  }

  private cargarParte_mantenimiento(): void {
    this.parte_mantenimientoService.getAll().subscribe({
      next: (data) => (this.parteMantenimiento = data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener parte mantenimiento:", error),
    });
  }

  openModalServicioRealizado(content: any, servicio?: any): void {
    if (servicio) {
      this.editMode = true;
      this.servicioSeleccionado = servicio;
      this.formServicio.patchValue(servicio); // Cargar datos para editar
    } else {
      this.editMode = false;
      this.formServicio.reset(); // Nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalServicioRef = modalRef;
  }

  guardarServicio(modalRef: NgbModalRef): void {
    this.validate = true;
    console.log("Datos del formulario de servicio:", this.formServicio.value);
    const datos = { ...this.formServicio.value };

    // Validar campos obligatorios con mensajes personalizados
    const camposObligatorios: {
      campo: string;
      mensaje: string;
      ref?: ElementRef;
    }[] = [
      {
        campo: "sistema",
        mensaje: "Por favor, ingresa el sistema",
        ref: this.inputSistema,
      },
      {
        campo: "parte",
        mensaje: "Por favor, ingresa la parte",
        ref: this.inputParte,
      },
      {
        campo: "tipo_de_mantenimiento",
        mensaje: "Selecciona un tipo de mantenimiento",
        ref: this.inputTipo,
      },
    ];

    for (const { campo, mensaje, ref } of camposObligatorios) {
      if (!this.formServicio.get(campo)?.value) {
        this.mostrarAlerta("Campo requerido", mensaje, "info");
        ref?.nativeElement.focus();
        return;
      }
    }

    datos.estado = 1; // Activado por defecto

    //id tipo de mantenimiento
    const idTipoMantenimiento = this.formServicio.get('tipo')?.value;
    datos.idTipoMantenimiento = idTipoMantenimiento;

    //id Servicio
    const idServicio = this.formServicio.get('servicio')?.value;
    datos.idServicio = idServicio;

    
    this.servicio_realizadoService.create(datos).subscribe({
      next: (servicioCreado) => {
        modalRef.close();

        this.servicio_realizadoService.getAll().subscribe({
          next: (data) => {
            this.servicios = data;
            this.servicioSeleccionado = servicioCreado.id;
            this.cargarServicio_realizado();
          },
          error: (err) => {
            console.error("Error al actualizar lista de servicios:", err);
          },
        });

        Swal.fire("Éxito", "Servicio registrado correctamente", "success");
      },
      error: () => {
        Swal.fire("Error", "No se pudo registrar el servicio", "error");
      },
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }


  guardarMantenimiento(): void {
    if (this.mantenimientos.length === 0) {
      Swal.fire("Advertencia", "No hay mantenimientos para guardar", "warning");
      return;
    }

    const datos = this.mantenimientos.map((item) => ({
      ...item,
      registro: new Date(),
      estado: 1,
    }));

    // Mostrar en consola lo que se va a enviar al backend
   // console.log("Datos que se envían al backend:", datos);

  this.matenimientosService.createMantenimiento(datos).subscribe({
  next: (response) => {
    if (response.codigo == 0) {
      Swal.fire("Éxito", "Manteniento registrado correctamente", "success");
      // 🔹 Vaciar tabla
        this.mantenimientos = [];

        // 🔹 Resetear el formulario si aplica
        this.formMantenimientos.reset();
      const basePath =
        this.administraciones[0].nit.toString() +
        "/mantenimientos/" +
        response.mantenimientos[0].placa +
        "/" +
        response.mantenimientos[0].id;

      let totalDropzones = this.dropzones.length;
      let completed = 0;

      this.dropzones.forEach((dz) => {
        if (dz.files && dz.files.length > 0) {
          const folder =
            dz.type === "pdf" ? `${basePath}/factura` : `${basePath}/imagenes`;

          this.digitalesService.uploadMultiple(dz.files, folder).subscribe({
            next: (event) => {
              if (event.type === HttpEventType.Response) {
             //   console.log(`✅ Dropzone ${dz.id} subida con éxito`, event.body);
                completed++;

                if (completed === totalDropzones) {
                //  console.log("🎉 Todas las subidas han terminado");
                  // 🔹 Resetear todos los dropzones
                  this.dropzones.forEach(dz => {
                    dz.files = [];
                  });
                  this.formMantenimiento.reset();
                  this.formNuevo.reset();
                  this.formMantenimientos.reset();
                  this.mantenimientos =[];
                }
              }
            },
            error: (err) => {
              console.error(`❌ Error en dropzone ${dz.id}`, err);
              completed++;
              if (completed === totalDropzones) {
                console.log("⚠️ Subidas finalizadas con errores");
              }
            },
          });


        } else {
          // Si no hay archivos en este dropzone, lo consideramos como completado
          totalDropzones--;
        }
      });
    }
  },
});
  }

  openModalEmpresa(content: any, empresa?: any): void {
    if (empresa) {
      this.editMode = true;
      this.empresaselecionada = empresa;
      this.formEmpresa.patchValue(empresa); // Carga datos en el formulario para editar
    } else {
      this.editMode = false;
      this.formEmpresa.reset(); // Limpia el formulario para un nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalEmpresaRef = modalRef;
  }

  guardarEmpresa(modalRef: NgbModalRef): void {
    this.validate = true;
    const datos = { ...this.formEmpresa.value };

    // Validación de correo
    const email = datos.email;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      this.mostrarAlerta(
        "Email inválido",
        "Correo no válido. Ej: usuario@dominio.com",
        "info"
      );
      return;
    }

    // Validar campos obligatorios con mensajes personalizados
    const camposObligatorios: {
      campo: string;
      mensaje: string;
      ref?: ElementRef;
    }[] = [
      {
        campo: "nit",
        mensaje: "Por favor, ingresa un número de documento",
        ref: this.inputNit,
      },
      {
        campo: "digito",
        mensaje: "Por favor, ingresa un dígito de verificación",
        ref: this.inputCodigo,
      },
      {
        campo: "nombre",
        mensaje: "Por favor, ingresa un nombre",
        ref: this.inputNombre,
      },
      {
        campo: "direccion",
        mensaje: "Por favor, ingresa una dirección",
        ref: this.inputDireccion,
      },
      {
        campo: "ciudad",
        mensaje: "Por favor, ingresa una ciudad",
        ref: this.inputCiudad,
      },
      {
        campo: "celular",
        mensaje: "Por favor, ingresa un número de celular",
        ref: this.inputCelular,
      },
      {
        campo: "email",
        mensaje: "Por favor, ingresa un correo electrónico",
        ref: this.inputEmail,
      },
    ];

   for (const { campo, mensaje, ref } of camposObligatorios) {
      const valor = this.formEmpresa.get(campo)?.value;
      
      // Para el campo digito, aceptar 0 como válido
      if (campo === 'digito') {
        if (valor === null || valor === undefined || valor === '') {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      } else {
        if (!valor) {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      }
    }


    // Convertir checkboxes a 1/0
    const checkboxKeys = [
      "eps",
      "arl",
      "afp",
      "ces",
      "ccf",
      "bancos",
      "transporte",
      "colegio",
      "cda",
      "taller",
      "eds",
      "contratista",
      "proveedor",
      "aseguradora",
      "almacen",
      "serviteca",
    ];
    checkboxKeys.forEach((k) => {
      // proveedor y taller deben enviarse siempre en 1
      if (k === 'proveedor' || k === 'taller') {
        datos[k] = 1;
      } else {
        datos[k] = datos[k] ? 1 : 0;
      }
    });

    datos.estado = 1; // Activar empresa al guardar
    this.empresasService.createEmpresa(datos).subscribe({
      next: (empresaCreada) => {
        modalRef.close();

        // 🔁 Recargar lista de talleres para incluir el nuevo
        this.cargarTaller();

        // Opcional: seleccionar automáticamente el taller recién creado
        this.formEmpresa.patchValue({ taller: empresaCreada.nombre });

        Swal.fire("Éxito", "Empresa registrada correctamente", "success");
      },
      error: () => {
        Swal.fire("Error", "No se pudo registrar la empresa", "error");
      },
    });
  }

  dropzones = [
    {
      id: 1,
      name: "SOPORTE DE FACTURA",
      files: [],
      error: null,
      eliminado: false,
      type: "pdf",
    },
    {
      id: 2,
      name: "SOPORTE DE MANTENIMIENTOS",
      files: [],
      error: null,
      eliminado: false,
      type: "image",
    },
  ];

  allowedImageTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
  maxImages = 10;

  onFileChange(event: any, dropzoneId: number): void {
    const files: FileList = event.target.files;
    const dropzone = this.dropzones.find((d) => d.id === dropzoneId);
    if (!dropzone || !files.length) return;

    dropzone.error = null;
    this.validFiles=[];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file.type === "application/pdf") {
        file["preview"] = this.sanitizer.bypassSecurityTrustResourceUrl(
          URL.createObjectURL(file)
        );
       this.validFiles.push(file);
      } else if (this.allowedImageTypes.includes(file.type)) {
        file["preview"] = URL.createObjectURL(file);
        this.validFiles.push(file);
      } else {
        dropzone.error =
          "Solo se permiten archivos PDF e imágenes PNG, JPG, JPEG, etc.";
        return;
      }
    }

    // Validar cantidad
    if (
      dropzone.type === "pdf" &&
      dropzone.files.length + this.validFiles.length > 1
    ) {
      dropzone.error = "Solo se permite un archivo PDF.";
      return;
    }

    if (
      dropzone.type === "image" &&
      dropzone.files.length + this.validFiles.length > this.maxImages
    ) {
      dropzone.error = `Máximo ${this.maxImages} imágenes permitidas.`;
      return;
    }

    dropzone.files = [...dropzone.files, ...this.validFiles];
    event.target.value = "";

    // Actualiza el campo documento con los nombres
    const allFiles = this.dropzones.flatMap((dz) => dz.files);
    this.formDocumentos.patchValue({
      documento: allFiles.map((f) => f.name).join(", "),
    });
  this.uploadDropzones(this.dropzones);
  }

removeFile(dropzoneId: number, index: number): void {
  const dropzone = this.dropzones.find((d) => d.id === dropzoneId);
  if (dropzone) {
    // Eliminar archivo de la lista
    dropzone.files.splice(index, 1);
    dropzone.error = null;

    // Reset input (para permitir volver a subir el mismo archivo si se quiere)
    const input = document.getElementById("fileInput" + dropzoneId) as HTMLInputElement;
    if (input) {
      input.value = "";
      input.blur();
    }

    // Mensaje de eliminado
    dropzone.eliminado = true;
    setTimeout(() => {
      dropzone.eliminado = false;
    }, 3000);

    // 🔹 Recalcular todos los archivos y actualizar el formulario
    const allFiles = this.dropzones.flatMap((dz) => dz.files);
    this.formDocumentos.patchValue({
      documento: allFiles.map((f) => f.name).join(", "),
    });
  }
}


  limpiarDropzone(dropzoneId: number): void {
    const dropzone = this.dropzones.find((d) => d.id === dropzoneId);
    if (dropzone) {
      dropzone.files = [];
      dropzone.error = null;
      const input = document.getElementById(
        "fileInput" + dropzoneId
      ) as HTMLInputElement;
      if (input) {
        input.value = "";
        input.blur();
      }
      dropzone.eliminado = true;
      setTimeout(() => {
        dropzone.eliminado = false;
      }, 3000);
    }
  }

  abrirInput(dropzoneId: number): void {
    const input = document.getElementById(
      "fileInput" + dropzoneId
    ) as HTMLInputElement;
    if (input) {
      input.click();
    }
  }

  agregarMantenimiento(): void {
    const camposRequeridos = [
      {
        campo: "fecha",
        mensaje: "Seleccione la fecha de realización",
        ref: this.inputFecha,
      },
      {
        campo: "placa",
        mensaje: "Seleccione la placa del vehículo",
        ref: this.inputPlaca,
      },
      { campo: "km", mensaje: "Ingrese el kilometraje", ref: this.inputKm },
      {
        campo: "idTipoMantenimiento",
        mensaje: "Seleccione el tipo de mantenimiento",
        ref: this.inputTipo,
      },
      {
        campo: "taller",
        mensaje: "Seleccione el proveedor o taller mecánico",
        ref: this.inputTaller,
      },
      {
        campo: "conductor",
        mensaje: "Seleccione el conductor",
        ref: this.inputConductor,
      },
      {
        campo: "factura",
        mensaje: "Ingrese el número de factura",
        ref: this.inputFactura,
      },
      {
        campo: "idFormaPago",
        mensaje: "Seleccione la forma de pago",
        ref: this.inputForma,
      },
      {
        campo: "idAccion",
        mensaje: "Seleccione el tipo de acción",
        ref: this.inputAccion,
      },
      {
        campo: "vrpagos",
        mensaje: "Ingrese el valor pagado",
        ref: this.inputVrPagos,
      },
      {
        campo: "servicio",
        mensaje: "Seleccione el servicio realizado",
        ref: this.inputServicio,
      },
    ];

    const esValorInvalido = (valor: any) =>
      valor === null ||
      valor === undefined ||
      (typeof valor === "string" && valor.trim() === "");

    for (const { campo, mensaje, ref } of camposRequeridos) {
      const valor = this.formMantenimiento.get(campo)?.value;
      if (esValorInvalido(valor)) {
        Swal.fire("Campo requerido", mensaje, "info");

        if ("nativeElement" in ref) {
          ref.nativeElement.focus();
        } else if ("focus" in ref) {
          ref.focus();
        }

        return;
      }
    }

    const {
      fecha,
      placa,
      km,
      idTipoMantenimiento,
      taller,
      servicio,
      idAccion,
      factura,
      idFormaPago,
      observacion,
      conductor,
      vrpagos,
    } = this.formMantenimiento.value;

    // Se buscan los objetos completos para conservar la descripción, no solo el id seleccionado
    const tipoMantenimientoObjeto = (this.TipoMantenimiento || []).find(
      (t: any) => t.id === idTipoMantenimiento,
    );
    const servicioObjeto = (this.servicioRealizado || []).find(
      (s: any) => s.id === servicio,
    );

    const accionObjeto = (this.tipoaccion || []).find(
      (a: any) => a.id === idAccion,
    );

    const formaPagoObjeto = (this.formapago || []).find(
      (f: any) => f.id === idFormaPago,
    );

    const nuevo = {
      fecha,
      placa,
      km,
      idTipoMantenimiento,
      tipo: tipoMantenimientoObjeto?.nombre ?? "",
      taller,
      idServicio: servicio,
      servicio: servicioObjeto?.tipo_de_mantenimiento ?? "",
      idAccion: accionObjeto?.id ?? null,
      accion: accionObjeto?.descripcion ?? "",
      factura,
      idFormaPago: formaPagoObjeto?.id ?? null,
      forma: formaPagoObjeto?.descripcion ?? "",
      observacion,
      conductor,
      vrpagos: this.valorFormateado || vrpagos,
    };
    console.log("Nuevo mantenimiento a agregar:", nuevo);
    this.mantenimientos.push(nuevo);
    this.formMantenimiento.patchValue({
      idAccion: null,
      idFormaPago: null,
      vrpagos: null,
      servicio: null,
    });
    this.valorFormateado = "";
  }

  eliminarMantenimiento(index: number): void {
    this.mantenimientos.splice(index, 1);
  }

  customSearchFn = (term: string, item: any) => {
    term = term.toLowerCase();

    const fullName = `${item.primernombre} ${item.segundonombre ?? ""} ${
      item.papellidos
    } ${item.seapellidos ?? ""}`.toLowerCase();
    const cedula = item.cedula?.toString().toLowerCase();

    return fullName.includes(term) || cedula.includes(term);
  };

    limitarLongitud(event: Event, max: number) {
  const input = event.target as HTMLInputElement;
  if (input.value.length > max) {
    input.value = input.value.slice(0, max);
    // Actualiza el FormControl asociado
    const controlName = input.getAttribute('formControlName');
    if (controlName) {
      this.formEmpresa.get(controlName)?.setValue(input.value);
    }
  }
}
async  uploadDropzones(dropzones1) {
   if (!this.dropzones.length) {
      alert('No hay archivos para subir');
      return;
    }

 
}

private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
       // console.log(data);
          this.administraciones = data;               
        
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 }

   private cargarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => (this.municipios = data),
    });
  }


}